import type { FileMeta } from '../../../shared/transfer.js';
import { formatBytes } from '../format.js';
import { el } from './dom.js';

export const createFileCard = (meta: FileMeta): HTMLElement =>
  el('section', { className: 'card file-card' }, [
    el('div', { className: 'file-card__icon', text: '◈' }),
    el('div', { className: 'file-card__body' }, [
      el('div', { className: 'file-card__name', text: meta.name, title: meta.name }),
      el('div', { className: 'file-card__size', text: `${formatBytes(meta.size)}${meta.mimeType ? ` · ${meta.mimeType}` : ''}` }),
    ]),
  ]);
